
export default {
    settings: {
        name: '',
    },
    currentStoryIndex: 0,
    stories: [
        {
            title: 'Tilly',
            image: {
                url: '/media/images/bg-menu-1.jpg',
                title: 'verhaal 1 kaft'
            },
        },
        {
            title: 'Een bad',
            image: {
                url: '/media/images/bg-menu-2.jpg',
                title: 'verhaal 2 kaft'
            }
        },
        {
            title: 'Lekker slapen',
            image: {
                url: '/media/images/bg-menu-2.jpg',
                title: 'verhaal 3 kaft'
            }
        },
        {
            title: 'Een eigen boekje',
            image: {
                url: '/media/images/bg-menu-2.jpg',
                title: 'verhaal 4 kaft'
            }
        },
        {
            title: 'De tostitest',
            image: {
                url: '/media/images/bg-menu-2.jpg',
                title: 'verhaal 5 kaft'
            }
        }
    ],

    setStoryIndex(index) {
        console.log('Settings current story index: ' + index);
        this.currentStoryIndex = index;
    }
}
